// import React from 'react';
// import { 
//   AlertTriangle, 
//   Code, 
//   Copy, 
//   Loader2, 
//   CheckCircle
// } from 'lucide-react';

// // Import the actual types from assistant-ui
// // If these imports don't work, you may need to check your assistant-ui version
// // and adjust the import paths accordingly

// // Fallback type definitions based on the error message
// type ReadonlyJSONObject = Record<string, unknown>;

// interface ToolCallContentPart<TArgs = ReadonlyJSONObject, TResult = unknown> {
//   readonly toolName: string;
//   readonly args: TArgs;
//   readonly argsText: string; // Note: NOT optional in assistant-ui
//   readonly toolCallId: string;
// }

// type ToolCallStatus = 
//   | { readonly type: "running" }
//   | { readonly type: "complete" }
//   | { readonly type: "incomplete"; readonly reason: "length" | "stop" | "cancelled" | "tool-calls" | "error"; readonly error?: unknown };

// // The exact interface assistant-ui expects
// interface AssistantUIToolFallbackProps extends ToolCallContentPart {
//   readonly status: ToolCallStatus;
// }

// // Create the component with exact typing
// export const ToolFallback: React.FC<AssistantUIToolFallbackProps> = ({ 
//   toolName, 
//   args, 
//   argsText, // This is required, not optional
//   toolCallId,
//   status 
// }) => {
//   const [copied, setCopied] = React.useState(false);

//   const handleCopyArgs = () => {
//     navigator.clipboard.writeText(argsText);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const getStatusConfig = (status: ToolCallStatus) => {
//     switch (status.type) {
//       case 'running':
//         return {
//           icon: Loader2,
//           iconClass: 'animate-spin h-5 w-5 text-blue-600',
//           bgClass: 'border-blue-200 bg-blue-50',
//           textClass: 'text-blue-700',
//           titleClass: 'text-blue-800',
//           codeClass: 'bg-blue-100 text-blue-800',
//           title: 'Tool Running...',
//           message: `Executing ${toolName}...`
//         };
//       case 'complete':
//         return {
//           icon: CheckCircle,
//           iconClass: 'h-5 w-5 text-green-600',
//           bgClass: 'border-green-200 bg-green-50',
//           textClass: 'text-green-700',
//           titleClass: 'text-green-800',
//           codeClass: 'bg-green-100 text-green-800',
//           title: 'Tool Completed',
//           message: `${toolName} executed successfully`
//         };
//       case 'incomplete':
//         const reason = status.reason;
//         let title = 'Tool Incomplete';
//         let message = `${toolName} did not complete`;
        
//         switch (reason) {
//           case 'cancelled':
//             title = 'Tool Cancelled';
//             message = `${toolName} was cancelled`;
//             break;
//           case 'length':
//             title = 'Tool Timeout';
//             message = `${toolName} took too long to execute`;
//             break;
//           case 'stop':
//             title = 'Tool Stopped';
//             message = `${toolName} was stopped`;
//             break;
//           case 'tool-calls':
//             title = 'Tool Chain Incomplete';
//             message = `${toolName} requires additional tool calls`;
//             break;
//           case 'error':
//             title = 'Tool Error';
//             message = status.error ? String(status.error) : `${toolName} failed to execute`;
//             break;
//         }

//         return {
//           icon: AlertTriangle,
//           iconClass: 'h-5 w-5 text-amber-600',
//           bgClass: 'border-amber-200 bg-amber-50',
//           textClass: 'text-amber-700',
//           titleClass: 'text-amber-800',
//           codeClass: 'bg-amber-100 text-amber-800',
//           title,
//           message
//         };
//     }
//   };

//   const config = getStatusConfig(status);
//   const IconComponent = config.icon;

//   return (
//     <div className={`border rounded-lg p-4 my-2 ${config.bgClass}`}>
//       <div className="flex items-start space-x-3">
//         <IconComponent className={`${config.iconClass} mt-0.5 flex-shrink-0`} />
        
//         <div className="flex-1 min-w-0">
//           <div className="flex items-center justify-between mb-2">
//             <h3 className={`text-sm font-medium ${config.titleClass}`}>
//               {config.title}
//             </h3>
//             <div className="text-xs text-gray-500 font-mono">
//               {toolCallId.slice(0, 8)}...
//             </div>
//           </div>
          
//           <div className="space-y-2">
//             <div className={`flex items-center space-x-2 text-sm ${config.textClass}`}>
//               <Code className="h-4 w-4" />
//               <span className="font-mono">{toolName}</span>
//             </div>
            
//             <p className={`text-sm ${config.textClass}`}>
//               {config.message}
//             </p>
            
//             {/* {status.type === 'incomplete' && status.reason === 'error' && status.error && (
//               <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
//                 <strong>Error:</strong> {String(status.error)}
//               </div>
//             )}
//              */}
//             {/* Show arguments - argsText is always available */}
//             {argsText && status.type !== 'running' && (
//               <div className="mt-3">
//                 <div className="flex items-center justify-between mb-1">
//                   <span className={`text-xs font-medium ${config.titleClass}`}>
//                     Arguments:
//                   </span>
//                   <button
//                     onClick={handleCopyArgs}
//                     className={`flex items-center space-x-1 text-xs ${config.textClass} hover:opacity-80 transition-opacity`}
//                   >
//                     <Copy className="h-3 w-3" />
//                     <span>{copied ? 'Copied!' : 'Copy'}</span>
//                   </button>
//                 </div>
                
//                 <div className={`${config.codeClass} rounded p-2 text-xs font-mono overflow-x-auto max-h-40 overflow-y-auto`}>
//                   <pre>{argsText}</pre>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Alternative approach: Use a type assertion to match assistant-ui's expected type
// export const ToolFallbackWithAssertion = ToolFallback as React.ComponentType<any>;


import { CheckIcon, ChevronDownIcon, ChevronUpIcon, Loader2Icon } from "lucide-react";
import { useState, FC } from "react";
import { Button } from "react-bootstrap";

interface ToolFallbackProps {
  toolName: string;
  argsText: string;
  result?: unknown;
  status?: { type: "running" | "complete" | "incomplete"; reason?: string };
}

export const ToolFallback: FC<ToolFallbackProps> = ({
  toolName,
  argsText,
  result,
  status,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isRunning = status?.type === "running" || (status === undefined && result === undefined);

  return (
    <div className={`aui-tool-fallback-root ${isRunning ? 'aui-tool-fallback-running' : ''}`}>
      <div className="aui-tool-fallback-header">
        {isRunning ? (
          <Loader2Icon className="aui-tool-fallback-icon aui-tool-fallback-icon-running" />
        ) : (
          <CheckIcon className="aui-tool-fallback-icon" />
        )}
        <p className="aui-tool-fallback-title">
          {isRunning ? 'Running tool: ' : 'Used tool: '}<b>{toolName}</b>
        </p>
        <Button onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Button>
      </div>
      {!isCollapsed && (
        <div className="aui-tool-fallback-content">
          <div className="aui-tool-fallback-args-root">
            <pre className="aui-tool-fallback-args-value">{argsText}</pre>
          </div>
          {result !== undefined && (
            <div className="aui-tool-fallback-result-root">
              <p className="aui-tool-fallback-result-header">Result:</p>
              <pre className="aui-tool-fallback-result-content">
                {typeof result === "string"
                  ? result
                  : JSON.stringify(result, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};


export const ToolFallbackWithAssertion = ToolFallback as React.ComponentType<any>;